import type { IconData } from '@stacksjs/iconify-core'

export const sword: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m6.778 10.728l1.414 1.414l8.436-8.435l-.236-1.179l-1.178-.236zM3.95 16.385a1 1 0 0 1-1.414 1.414L1.12 16.385a1 1 0 0 1 1.415-1.414l2.828-2.829l-1.414-1.414a1 1 0 0 1 1.414-1.414L14.556.12l3.536.707l.707 3.536l-9.192 9.192a1 1 0 1 1-1.415 1.415l-1.414-1.415l-2.828 2.829z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default sword
